import React from "react";
import "../../../styles/loaders/dot-loaders.css";

const DotLoaders = ({ color }) => {
  const style = color ? { '--dot-color': color } : {};
  
  return (
    <div className="dot-loader" style={style}>
      <span></span>
    </div>
  );
};

export default DotLoaders;
